import { render, staticRenderFns } from "./DocumentDescription.vue?vue&type=template&id=5c62adb4&scoped=true"
import script from "./DocumentDescription.vue?vue&type=script&lang=ts"
export * from "./DocumentDescription.vue?vue&type=script&lang=ts"
import style0 from "./DocumentDescription.vue?vue&type=style&index=0&id=5c62adb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62adb4",
  null
  
)

export default component.exports